import { render, staticRenderFns } from "./TextboxSetting.vue?vue&type=template&id=222a6d9d&scoped=true&lang=pug"
import script from "./TextboxSetting.vue?vue&type=script&lang=ts"
export * from "./TextboxSetting.vue?vue&type=script&lang=ts"
import style0 from "./TextboxSetting.vue?vue&type=style&index=0&id=222a6d9d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222a6d9d",
  null
  
)

export default component.exports